<template>
    <div>
        123
        <van-button type="primary" @click="goHome">返回</van-button>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    methods:{
        goHome(){
            history.go(-1)
        }
    }
}
</script>

<style scoped>

</style>